var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.034 5.87231C4.70449 5.54281 4.17026 5.54281 3.84076 5.87231C3.51125 6.20182 3.51125 6.73605 3.84076 7.06555L8.90325 12.1281C9.23276 12.4576 9.76699 12.4576 10.0965 12.1281L15.159 7.06555C15.4885 6.73605 15.4885 6.20182 15.159 5.87231C14.8295 5.54281 14.2953 5.54281 13.9658 5.87231L9.49988 10.3382L5.034 5.87231Z","fill":"#7C7C87"}));
}

ChevronDownInline.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
